import { render } from "./BlockHorizontalText.vue?vue&type=template&id=6f0f932a"
import script from "./BlockHorizontalText.vue?vue&type=script&lang=js"
export * from "./BlockHorizontalText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__